module.exports = __webpack_public_path__ + "img/branch.0244e31b.svg";